import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { LoadingService } from '../shared/services/Loading/Loading.Service';
import { Title, Meta } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { AdminDataKeyWordDto } from '../shared/models/dtos/admindata/adminDataKeyWordDto';
import { VehicleByGroupRequestData } from '../shared/models/dtos/vehicleInquirie/vehicleByGroupRequestData';
import { ContactService } from '../shared/services/static-page/contact.service';
import { VisaCountryService } from '../shared/services/visa-country.service';
import { VisaTypeService } from '../shared/services/visa-type.service';
import { VisaService } from '../shared/services/visa.service';
import { VisitReasonService } from '../shared/services/visit-reason.service';
import { environment } from '../../environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { HomeSliderComponent } from '../shared/components/home-slider/home-slider.component';
import { AdminData_Service } from '../shared/services/admindata/admin-data.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { VisaSelect, VisaCountry } from '../shared/Core/visa.data';
import { GoogleAnalyticsService } from '../shared/services/google-analytics.service';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, RouterModule, FormsModule, ReactiveFormsModule, CommonModule, SelectDropDownModule, HomeSliderComponent, NgxSpinnerModule],
  templateUrl: './app-layout.html',
  styleUrls: ['./app-layout.scss'],
  standalone: true,
})
export class AppLayoutComponent {
  title = 'VizeAsist';

  private clickListener: (() => void) | undefined;
  _visaCountryService = inject(VisaCountryService);
  _visitReasonService = inject(VisitReasonService);
  _visitTypeService = inject(VisaTypeService);
  _visaService = inject(VisaService);

  constructor(
    @Inject(Renderer2) private renderer: Renderer2,
    private titleService: Title,
    private metaService: Meta,
    private adminDataService: AdminData_Service,
    public googleAnalyticsService: GoogleAnalyticsService,
    public router: Router,
    private readonly contactService: ContactService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showLayout = !event.url.startsWith('/payment-callback');
      }
    });
  }

  private apiUrl = environment.apiUrl.slice(0, -4);
  showLayout = true;
  isShow: boolean = false;
  contact: any;
  locationLink: any;
  menuOpen = false;
  siteLogo: string = '';
  sliderLogo: string = '';
  siteLogoUrl: string = '';
  sliderLogoUrl: string = '';
  requestData: VehicleByGroupRequestData = {};
  years: any;
  selectedYear: string = 'Yıl';
  selectedBrandName: string = 'Marka';
  selectedBrandId: number = 0;
  brands: any;
  showVisaCountryRequired: boolean = false;
  showVisitReasonRequired: boolean = false;
  showVisaTypeRequired: boolean = false;
  dropdownOptionsCountry = [];
  dropdownOptionsVisitReason = [];
  dropdownOptionsVisaType = [];
  ngModelVisaCountry: any;
  ngModelVisaReason: any;
  ngModelVisaType: any;
  Instagram: string | undefined = '';
    TursabBelgeNo: string | undefined = '';
  YouTube: string | undefined = '';
  LinkedIn: string | undefined = '';
  Twitter: string | undefined = '';
  Facebook: string | undefined = '';
  webVersion: string = '1.0.6';
  apiVersion: string = '';

  configCountry = {
    displayKey: 'name',
    search: true,
    height: '186px',
    placeholder: 'Ülke Seç',
    customComparator: (a: any, b: any) => {
      return 0;
    },
    limitTo: 0,
    moreText: 'dahası',
    noResultsFound: 'Sonuç bulanamadı!',
    searchPlaceholder: 'Ara',
    searchOnKey: 'name',
    clearOnSelection: false,
    inputDirection: 'ltr',
    selectAllLabel: 'Tümünü Seç',
    enableSelectAll: false,
  };

  configVisaType = {
    displayKey: 'name',
    search: true,
    height: '186px',
    placeholder: 'Vize Türü Seç',
    customComparator: (a: any, b: any) => {
      return 0;
    },
    limitTo: 0,
    moreText: 'dahası',
    noResultsFound: 'Sonuç bulanamadı!',
    searchPlaceholder: 'Ara',
    searchOnKey: 'name',
    clearOnSelection: false,
    inputDirection: 'ltr',
    selectAllLabel: 'Tümünü Seç',
    enableSelectAll: false,
  };

  configVisaTime = {
    displayKey: 'name',
    search: true,
    height: '186px',
    placeholder: 'Vize Süresi',
    customComparator: (a: any, b: any) => {
      return 0;
    },
    limitTo: 0,
    moreText: 'dahası',
    noResultsFound: 'Sonuç bulanamadı!',
    searchPlaceholder: 'Ara',
    searchOnKey: 'name',
    clearOnSelection: false,
    inputDirection: 'ltr',
    selectAllLabel: 'Tümünü Seç',
    enableSelectAll: false,
  };

  selectedCountry: any = null;
  selectedVisitReason: any = null;
  selectedVisaType: any = null;

  async ngOnInit(): Promise<void> {
    
    // SSR için ana sayfa kontrolü - her zaman true olarak başlat
    this.isShow = this.router.url == '/'

    
    this.getKeyWord();
    
    // Google Analytics script'ini sadece browser'da yükle (prerender/SSR'de çağrı yapma)
    if (isPlatformBrowser(this.platformId)) {
      await this.googleAnalyticsService.loadGoogleAnalyticsScript();
    }
    
    // Contact verilerini yükle
    try {
      let data = await firstValueFrom(this.contactService.getContact());
      this.contact = data[0];
      if (this.contact && this.contact.locationLink) {
        const regex = /src=\"([^\"]*)\"/;
        const match = this.contact.locationLink.match(regex);
        this.locationLink = match ? match[1] : null;
      }
    } catch (error) {
      console.error('Error loading contact data:', error);
    }
    
    // Visa country verilerini yükle
    this._visaCountryService.getAll().subscribe((data) => {
      this.dropdownOptionsCountry = data;
    });

    // Client-side'da Google Analytics script'ini inject et
    if (isPlatformBrowser(this.platformId)) {
      this.googleAnalyticsService.injectClientSideScript();
    }

    // Router events sadece browser'da çalışsın
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe(async (event) => {
        if (event instanceof NavigationEnd) {
          // Ana sayfa veya visa sayfası kontrolü
          this.isShow = this.router.url === '/' && !this.router.url.includes('visa');

          var currentDate = new Date();
          var reloadTime = sessionStorage.getItem('reloadTime');
          if (reloadTime) {
            var reloadDate = new Date(reloadTime);
            var timeDifference = currentDate.getTime() - reloadDate.getTime();
            const tenMinutes = 10 * 60 * 1000;
          }

          if (!this.router.url.includes('visa')) this.scrollTop();

          // Ana sayfaya dönüldüğünde veya visa sayfasından geri dönüldüğünde
          if (this.router.url === '/' || this.router.url.includes('visa')) {
            // Tüm seçimleri sıfırla
            this.selectedCountry = null;
            this.selectedVisitReason = null;
            this.selectedVisaType = null;
            this.ngModelVisaCountry = null;
            this.ngModelVisaReason = null;
            this.ngModelVisaType = null;
            this.showVisaCountryRequired = false;
            this.showVisitReasonRequired = false;
            this.showVisaTypeRequired = false;

            // Session storage'ı temizle
            sessionStorage.removeItem('selectedCountry');
            sessionStorage.removeItem('selectedVisitReason');
            sessionStorage.removeItem('selectedVisaType');
          }

          if (this.router.url === '/') {
            this.isShow = true;
            this.selectedCountry = null;
            this.selectedVisitReason = null;
            this.ngModelVisaCountry = null;
            this.ngModelVisaType = null;
            this.ngModelVisaReason = null;
            this.showVisaCountryRequired = false;
            this.showVisitReasonRequired = false;
            this.showVisaTypeRequired = false;
          } else {
            this.selectedYear = 'Yıl';
            this.selectedBrandName = 'Marka';
            this.selectedBrandId = 0;
            // visa sayfalarında form alanlarını gizle
            if (this.router.url.includes('visa')) {
              this.isShow = false;
            }
          }
        }
      });
    }
  }

  search() {
    if (!this.selectedCountry) {
      this.showVisaCountryRequired = true;
      return;
    }
    if (!this.selectedVisitReason) {
      this.showVisitReasonRequired = true;
      return;
    }
    if (this.dropdownOptionsVisaType.length > 0 && !this.selectedVisaType) {
      this.showVisaTypeRequired = true;
      return;
    }
    this.router.navigate(['/visa']);
  }
  reloadPage() {
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.removeItem('selectedVisaType');
      sessionStorage.removeItem('selectedVisitReason');
      sessionStorage.removeItem('selectedCountry');
    }
    this.router.navigate(['/arac-sat']).then(() => {
      if (isPlatformBrowser(this.platformId)) {
        window.location.reload();
      }
    });
  }

  onChangeVisaCountry(event: any) {
    this.ngModelVisaReason = null;
    this.selectedCountry = event.value;
    this._visaService.setVisaCountry(this.selectedCountry);
    if (this.dropdownOptionsVisaType.length > 0) this.dropdownOptionsVisaType.length = 0;

    if (this.selectedCountry) {
      this.showVisaCountryRequired = false;
    }
    this._visitReasonService.getByCountryId(this.selectedCountry.id).subscribe((data) => {
      this.dropdownOptionsVisitReason = data;
    });
  }

  onChangeVisaType(event: any) {
    this.selectedVisaType = event.value;
    this.ngModelVisaType = event.value;
    this._visaService.setVisaType(this.selectedVisaType);

    if (this.selectedVisaType) {
      this.showVisaTypeRequired = false;
    }
  }
  onChangeVisitReason(event: any) {
    this.selectedVisitReason = event.value;
    this._visaService.setVisitReason(this.selectedVisitReason);
    if (this.dropdownOptionsVisaType.length > 0) this.dropdownOptionsVisaType.length = 0;
    this._visitTypeService.getByCountryId(this.selectedCountry.id, this.selectedVisitReason.id).subscribe((data) => {
      this.dropdownOptionsVisaType = data;
    });
    if (this.selectedVisitReason) {
      this.showVisitReasonRequired = false;
    }
  }

  getKeyWord() {
    this.adminDataService.getKeyWord().subscribe((data: AdminDataKeyWordDto[]) => {
      let title = data.find((f) => f.name == 'SiteTitle')?.description;
      let keywords = data.find((f) => f.name == 'MetaKeyword')?.description;
      let description = data.find((f) => f.name == 'MetaDescription')?.description;
      let slogan = data.find((f) => f.name == 'Slogan')?.description;

      this.Instagram = data.find((f) => f.name == 'Instagram')?.description;
      this.TursabBelgeNo = data.find((f) => f.name == 'TursabBelgeNo')?.description;
      this.YouTube = data.find((f) => f.name == 'YouTube')?.description;
      this.LinkedIn = data.find((f) => f.name == 'LinkedIn')?.description;
      this.Twitter = data.find((f) => f.name == 'Twitter')?.description;
      this.Facebook = data.find((f) => f.name == 'Facebook')?.description;

      this.siteLogo = data.find((f) => f.name == 'SiteLogo')?.description ?? '';

      if (this.siteLogo == '') this.siteLogoUrl = '';
      else this.siteLogoUrl = this.apiUrl + this.siteLogo;

      // Slider verisini parse et ve doğru URL'yi oluştur
      const sliderData = data.find((f) => f.name == 'Slider')?.description;
      if (sliderData) {
        try {
          const parsedSlider = JSON.parse(sliderData);
          if (parsedSlider && parsedSlider.length > 0) {
            this.sliderLogoUrl = this.apiUrl + parsedSlider[0].ImageUrl;
          } else {
            this.sliderLogoUrl = 'assets/images/slider-default.jpg';
          }
        } catch (e) {
          this.sliderLogoUrl = 'assets/images/slider-default.jpg';
        }
      } else {
        this.sliderLogoUrl = 'assets/images/slider-default.jpg';
      }

      if (this.siteLogoUrl)
        this.metaService.updateTag({
          property: 'og:image',
          content: this.siteLogoUrl,
        });

      if (this.router.url == '/') {
        this.titleService.setTitle(title ?? 'www.VizeAsist.com ');
      }

      if (this.router.url != '/') {
        this.titleService.setTitle(slogan + ' | ' + this.router.url.replace('-', ' ').replace('/', ''));
      }
      this.metaService.updateTag({
        name: 'description',
        content: description ?? '',
      });
      this.metaService.updateTag({
        name: 'keywords',
        content: keywords ?? '',
      });
    });
  }
  scrollTop() {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll({
        top: 0,
        behavior: 'smooth',
      });
    }
  }

  // Menü açma/kapatma işlevi
  toggleMenu() {
    this.menuOpen = !this.menuOpen; // Menü durumunu tersine çevirir (açık/kapalı)
    if (this.menuOpen) {
      // Menü açıldığında, dışarıya tıklama dinleyicisini ekler
      this.addClickListener();
    } else {
      // Menü kapandığında, dışarıya tıklama dinleyicisini kaldırır
      this.removeClickListener();
    }
  }

  // Dışarıya tıklama dinleyicisini ekler
  addClickListener() {
    this.clickListener = this.renderer.listen('document', 'click', (event) => {
      // Eğer tıklama 'nav' elemanının dışındaysa
      if (!event.target.closest('nav')) {
        this.menuOpen = false; // Menü kapatılır
        this.removeClickListener(); // Tıklama dinleyicisi kaldırılır
      }
    });
  }

  // Dışarıya tıklama dinleyicisini kaldırır
  removeClickListener() {
    if (this.clickListener) {
      this.clickListener(); // Dinleyiciyi çağırarak kaldırır
      this.clickListener = undefined; // Dinleyiciyi undefined yapar
    }
  }

  // Angular bileşeni yok edildiğinde çağrılan yaşam döngüsü kancası
  ngOnDestroy() {
    this.removeClickListener(); // Bileşen yok edildiğinde tıklama dinleyicisini kaldırır
  }

  openVisa() {
    const url = this.router.url;
    // rputer with params
    if (url == '/visa?type=firstStep') {
      window.location.reload();
    } else {
      this.router.navigate(['/visa'], {
        queryParams: {
          type: 'firstStep',
        },
      });
    }
    this._visaService.setVisaType({} as VisaSelect);
    this._visaService.setVisaCountry({} as VisaCountry);
    this._visaService.setVisitReason({} as VisaSelect);
  }
}
